import React, { useEffect } from 'react'

const CookieBanner = ({ cookieBannerInfo = {} }) => {
  const { html = '', js = '' } = cookieBannerInfo
  const head = document.head || document.getElementsByTagName('head')[0]
  useEffect(() => {
    let jscriptWithScriptTag = decodeURIComponent(js)
    const jsRegexMatch = jscriptWithScriptTag.match(
      /nonce="(.*?)">(.*?)<\/script>/,
    )
    const cssRegexMatch = cookieBannerInfo.css.match(
      /nonce="(.*?)">(.*?)<\/style>/,
    )
    const nonceCalculated =
      jsRegexMatch && jsRegexMatch.length > 1 && jsRegexMatch[1]
    const cssNonceCalculated =
      cssRegexMatch && cssRegexMatch.length > 1 && cssRegexMatch[1]
    const jscript = jsRegexMatch && jsRegexMatch.length > 2 && jsRegexMatch[2]
    const css = cssRegexMatch && cssRegexMatch.length > 2 && cssRegexMatch[2]
    const styleElement = document.createElement('style')
    styleElement.setAttribute('nonce', cssNonceCalculated)
    head.appendChild(styleElement)
    styleElement.appendChild(document.createTextNode(css))
    const scriptElement = document.createElement('script')
    scriptElement.setAttribute('nonce', nonceCalculated)
    scriptElement.innerHTML = jscript
    document.body.append(scriptElement)

    return () => {
      document.body.removeChild(scriptElement)
      document.head.removeChild(styleElement)
    }
  })

  return (
    <div>
      {html && (
        <div data-test-id="html" dangerouslySetInnerHTML={{ __html: html }} />
      )}
    </div>
  )
}

export default CookieBanner
